// eslint-disable-next-line no-unused-vars
import React, { useEffect } from 'react';
import { initFacebookPixel } from './facebookPixel';
import useUser from 'core/hooks/useUser';
import { facebookId } from 'reactAppConstants';

const FacebookPixelInitializer = () => {
  const { currentUser } = useUser();
  const externalId = currentUser && currentUser.externalId;

  useEffect(() => {
    if (!!facebookId && externalId) {
      initFacebookPixel(facebookId, externalId);
    }
  }, [externalId]);

  return null;
};

export default FacebookPixelInitializer;
